var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataGraphic = function SvgDataGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.333 5.333v53.334h53.334v-5.334h-48v-48zm13.867 35.2 11.52-11.52 9.387 9.387 15.146-15.147-3.84-3.84-11.306 11.52-9.387-9.386-15.36 15.146z"
  })));
};
export default SvgDataGraphic;